<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { ref, inject, defineProps } from 'vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    color: {
        type: String,
        default: '#1976D2'
    },
    disabled: {
        type: Boolean,
        default: false
    },
    click: {
        type: Function,
        required: true
    }
});

/*==================================================================*/
/*================== LOADING =======================================*/
/*==================================================================*/

const loading = ref(false);

/*==================================================================*/
/*================== INJECT ALTERA DISABLE =========================*/
/*==================================================================*/

const alteraDisable = inject('alteraDisable', null);

/*==================================================================*/
/*================== AO CLICAR =====================================*/
/*==================================================================*/

const aoClicar = async () => {

    loading.value = true;
    alteraDisable?.(true);

    try{

        await props.click();

    } finally{

        loading.value = false;
        alteraDisable?.(false);

    }

};

</script>

<template>

    <div class="c-botao">

        <v-tooltip bottom>

            <template #activator="{ on, attrs }">

                <v-btn
                    class="c-inner-botao"
                    v-bind="attrs"
                    :color="props.color"
                    :style="{ '--botao-cor': props.color }"
                    dark
                    v-on="on"
                    @click="aoClicar"
                    :disabled="props.disabled"
                    :loading="loading"
                >

                    <slot></slot>

                </v-btn>

            </template>

            <div class="c-tooltip">
                <slot name="tooltip"><slot></slot></slot>
            </div>

        </v-tooltip>

    </div>

</template>

<style scoped>

.c-inner-botao{
    width: inherit;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-inner-botao {
    background: var(--botao-cor) !important;
    border-color: var(--botao-cor) !important;
}


</style>
